import React, { useState } from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker, { Calendar } from "react-modern-calendar-datepicker";
import moment from "jalali-moment";

//local
import "./MyList.css";
import { MyText, MyButton, TextInput } from "../";
import { addCommas } from "../../utils";
import { Link } from "react-router-dom";
// import { apiAddress } from "../../utils";

const itemsTitle = [
  "شماره کاربر",
  "نام کاربر",
  "شماره موبایل",
  "تاریخ ثبت نام",
  "عملیات",
];

const MyList = ({ data, token, pages, setPage, page, totalDocs }) => {
  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null,
  });
  return (
    <>
      <div className="myList">
        <div style={{ width: "100%" }}>
          <div className="myList__header">
            <div className="myList__header--buttons">
              <MyText color="#2d3ab5" size="1.2rem">
                جدول
              </MyText>
            </div>
            <MyText color="black" size="1.2rem">
              تعداد : {addCommas(totalDocs)}
            </MyText>
          </div>
          <div className="myList__header">
            <div className="myList__header--buttons">
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ marginLeft: "1rem" }}>متن جست و جو :</div>
                <input type="text" />
              </div>
              <div
                style={{
                  display: "flex",
                  marginRight: "2rem",
                  alignItems: "center",
                }}
              >
                <div style={{ marginLeft: "1rem" }}>تاریخ :</div>
                <DatePicker
                  value={selectedDayRange}
                  onChange={setSelectedDayRange}
                  inputPlaceholder="انتخاب نمایید"
                  shouldHighlightWeekends
                  locale="fa" // add this
                />
              </div>
              <div
                style={{
                  display: "flex",
                  marginRight: "2rem",
                  alignItems: "center",
                }}
              >
                <div style={{ marginLeft: "1rem" }}>پرداخت موفق :</div>
                <input type="checkbox" />
              </div>
            </div>
            <button type="button" class="btn btn-success ">
              جست و جو
            </button>
          </div>
        </div>
        <div className="myList__itemsTitle">
          {itemsTitle.map((value) => (
            <div className="myList__itemsTitle--item">
              <MyText color="#50525c" size="1rem">
                {value}
              </MyText>
            </div>
          ))}
        </div>
        <div className="myList__itemsContainer">
          {data.map((item, index) => (
            <div className="myList__items">
              <div className="myList__item">
                <div className="myList__item">
                  <MyText color="#23242b" size="1rem">
                    {Number(index + 1) * Number(page)}
                  </MyText>
                </div>
                <div className="myList__item">
                  <MyText color="#23242b" size="1rem">
                    {item.name}
                  </MyText>
                </div>
                <div className="myList__item" style={{ direction: "ltr" }}>
                  <MyText color="#23242b" size="1rem">
                    {item.country_code + item.phone_number}
                  </MyText>
                </div>
                <div className="myList__item" style={{ direction: "ltr" }}>
                  <MyText color="#23242b" size="1rem">
                    {moment(item.creation_date)
                      .locale("fa")
                      .format("YYYY/MM/DD, h:mm:ss a")}
                  </MyText>
                </div>
                <div className="myList__item">
                  <Link
                    to={{
                      pathname: "/dashboard/userDetails/" + item._id,
                      query: { data: item },
                    }}
                  >
                    <button
                      type="button"
                      class="btn btn-primary round mr-1 mb-1 btn-sm"
                    >
                      جزییات
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="myList__footer">
        <div className="myList__footerPagination">
          {page !== 1 ? (
            <div
              onClick={() => setPage(page - 1)}
              className="myList__footerPagination--item"
            >
              قبلی
              {/* <span className="icon-bell" /> */}
            </div>
          ) : null}
          {pages - 2 <= page + 1 ? (
            <div className="myList__footerPagination--item">
              <MyText marginTop="0.3rem">...</MyText>
            </div>
          ) : null}
          <div
            onClick={() => setPage(page)}
            className="myList__footerPagination--item active"
          >
            <MyText marginTop="0.3rem">{page}</MyText>
          </div>
          {pages === page ? null : (
            <div
              className="myList__footerPagination--item"
              onClick={() => setPage(page + 1)}
            >
              <MyText marginTop="0.3rem">{page + 1}</MyText>
            </div>
          )}

          {pages - 2 <= page + 1 ? null : (
            <div className="myList__footerPagination--item">
              <MyText marginTop="0.3rem">...</MyText>
            </div>
          )}
          {pages - 1 <= page + 1 ? null : (
            <div
              onClick={() => setPage(pages - 1)}
              className="myList__footerPagination--item"
            >
              <MyText marginTop="0.3rem">{pages - 1}</MyText>
            </div>
          )}
          {pages <= page + 1 ? null : (
            <div
              onClick={() => setPage(pages)}
              className="myList__footerPagination--item"
            >
              <MyText marginTop="0.3rem">{pages}</MyText>
            </div>
          )}
          {pages === page ? null : (
            <div
              onClick={() => setPage(page + 1)}
              className="myList__footerPagination--item"
            >
              {/* <span className="icon-bell" /> */}
              بعدی
            </div>
          )}
        </div>
        <div className="myList__footerHelp">
          <div className="myList__footerHelp--item">
            <div className="myList__footerHelp--itemDot" />
            <MyText color="#ffad2b" size="12px">
              نیاز به پیگیری
            </MyText>
          </div>
          <div className="myList__footerHelp--item">
            <div className="myList__footerHelp--itemDot green" />
            <MyText color="#37ac68" size="12px">
              پیگیری شده
            </MyText>
          </div>
        </div>
      </div>
    </>
  );
};

export { MyList };
